/* ---------------------------------------------------------------
   Arabic labels for JavaScript-rendered UI.

   sf-claude.js and sf-bundlefilters.js build the filter drawer, sort menu,
   bag drawer and bundle builder as HTML strings. They cannot read the
   locale files, so sf-bundlestrings.liquid hands us a table keyed by the
   English source text and this applies it after each render.

   TWO KINDS OF TEXT.
   1. Fixed labels — "Quick add", "Full rim", "Choose colour". A plain
      lookup, and they live in sf-bundlestrings.
   2. Sentences assembled around numbers — "Pick 2 from the 25 KD range —
      0 of 2 selected · 923 frames in 150 families". A lookup cannot reach
      those, because the string only exists once the numbers are in it, so
      they are matched as patterns here and rebuilt in Arabic with the
      numbers put back where Arabic wants them.

   ORDER MATTERS IN THE PATTERN LIST. The first match wins, so anything
   specific has to sit above anything general: "2 for 40 KD added · in your
   bag" has to be caught before the bare "2 for 40 KD" rule gets to it, or
   the toast is half translated.

   ONLY TEXT NODES ARE TOUCHED. Attributes, values, data-* and anything in
   a <script> or <svg> are left alone, because the filters compare against
   the English metafield values. Translating a value rather than a label
   would break filtering silently.

   Runs on Arabic only — the table does not exist otherwise.
   --------------------------------------------------------------- */
(function () {
  var T = window.SF_T;
  if (!T) return;

  // Longest first, so "Acetate and metal" is never half-matched by "Acetate".
  var keys = Object.keys(T).sort(function (a, b) { return b.length - a.length; });

  /* Patterns run before the plain lookup. Numbers stay Western to match
     the prices Shopify renders. The dash between clauses may be an em dash
     or a hyphen depending on where the string was built, so both are
     accepted. */
  var PATTERNS = [
    /* The builder's status line. Since the grid became one card per family
       it counts both: how many frames are on offer, and how many families
       they sit in. */
    [/^Pick (\d+) from the ([\d.,]+ ?KD) range\s*[\u2014-]\s*(\d+) of (\d+) selected\s*\u00B7\s*(\d+) frames in (\d+) families$/,
      function (m) {
        return 'اختر ' + m[1] + ' من فئة ' + m[2] + ' \u2014 اخترت ' + m[3] + ' من ' + m[4] +
               ' \u00B7 ' + m[5] + ' نظارة في ' + m[6] + ' مجموعة';
      }],

    [/^Pick (\d+) from the ([\d.,]+ ?KD) range\s*[\u2014-]\s*(\d+) of (\d+) selected\s*\u00B7\s*(\d+) to choose from$/,
      function (m) {
        return 'اختر ' + m[1] + ' من فئة ' + m[2] + ' \u2014 اخترت ' + m[3] + ' من ' + m[4] +
               ' \u00B7 ' + m[5] + ' متاحة';
      }],

    [/^Pick (\d+) from the ([\d.,]+ ?KD) range\s*[\u2014-]\s*loading frames$/,
      function (m) { return 'اختر ' + m[1] + ' من فئة ' + m[2] + ' \u2014 جاري تحميل النظارات'; }],

    [/^Any (\d+)\s*\u00B7\s*([\d.,]+ ?KD) frames\s*\u00B7\s*normally (.+)$/,
      function (m) {
        return 'أي ' + m[1] + ' \u00B7 نظارات ' + m[2] + ' \u00B7 بدلاً من ' + m[3];
      }],

    /* Above the bare "N for X" rule, or that would swallow the toast. */
    [/^(\d+) for (.+) added\s*\u00B7\s*in your bag$/,
      function (m) { return m[1] + ' بـ ' + m[2] + ' \u00B7 أضيفت إلى حقيبتك'; }],

    [/^(\d+) for (.+)$/, function (m) { return m[1] + ' بـ ' + m[2]; }],

    [/^Set of (\d+)$/, function (m) { return 'طقم من ' + m[1]; }],

    [/^Part of a bundle of (\d+)$/, function (m) { return 'ضمن باقة من ' + m[1]; }],

    [/^(\d+) to choose from$/, function (m) { return m[1] + ' متاحة'; }],

    [/^(\d+) of (\d+) selected$/,
      function (m) { return 'اخترت ' + m[1] + ' من ' + m[2]; }],

    /* The family grid's own counters, on the card and in the filter bar. */
    [/^(\d+) of (\d+) families$/,
      function (m) { return m[1] + ' من ' + m[2] + ' مجموعة'; }],

    [/^(\d+) families$/, function (m) { return m[1] + ' مجموعة'; }],

    [/^(\d+) family$/, function () { return 'مجموعة واحدة'; }],

    [/^(\d+) colours$/, function (m) { return m[1] + ' ألوان'; }],

    [/^Show (\d+) more$/, function (m) { return 'عرض ' + m[1] + ' أخرى'; }],

    [/^Choose (\d+) more$/, function (m) { return 'اختر ' + m[1] + ' أخرى'; }],

    [/^Pick (\d+) more$/, function (m) { return 'اختر ' + m[1] + ' أخرى'; }],

    [/^You save (.+)$/, function (m) { return 'توفّر ' + m[1]; }],

    [/^Same (.+)$/, function (m) { return 'نفس ' + (T[m[1]] || m[1]); }]
  ];

  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, SVG: 1, PATH: 1 };

  function translate(trimmed) {
    for (var i = 0; i < PATTERNS.length; i++) {
      var m = trimmed.match(PATTERNS[i][0]);
      if (m) return PATTERNS[i][1](m);
    }
    if (T[trimmed]) return T[trimmed];
    return null;
  }

  function swapIn(root) {
    if (!root || root.nodeType !== 1) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
        if (p.closest && p.closest('svg')) return NodeFilter.FILTER_REJECT;
        return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);

    nodes.forEach(function (node) {
      var text = node.nodeValue;
      var trimmed = text.trim();

      var whole = translate(trimmed);
      if (whole !== null) {
        node.nodeValue = text.replace(trimmed, whole);
        return;
      }

      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        if (trimmed.indexOf(k) !== -1) {
          node.nodeValue = text.split(k).join(T[k]);
          return;
        }
      }
    });
  }

  function run() { swapIn(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* The drawers and the builder repaint long after load — a filter click,
     a bundle selection, opening the bag — so new markup is translated as it
     arrives. The observer is disconnected while we edit so it does not
     react to our own changes. */
  var observer = new MutationObserver(function (records) {
    observer.disconnect();
    records.forEach(function (r) {
      if (r.type === 'childList') {
        Array.prototype.forEach.call(r.addedNodes, function (node) {
          if (node.nodeType === 1) swapIn(node);
          else if (node.nodeType === 3 && node.parentNode) swapIn(node.parentNode);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();